import { createFileRoute, redirect } from '@tanstack/react-router'

import { ROLES } from '@/entities/auth'
import { RecruitmentPage, type RecruitmentSearchParams } from '@/pages/recruitment-page'

export const Route = createFileRoute('/_dashboard/recruitment/')({
    onEnter: () => {
        document.title = 'Taxoparkee - Заявки'
    },
    beforeLoad: ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager, ROLES.recruiter])) {
            throw redirect({
                to: '/support',
            })
        }
    },
    validateSearch: (search: Record<string, unknown>): RecruitmentSearchParams => {
        return {
            page: (search?.page as number) ?? 1,
            phone: search?.phone?.toString(),
            from_date: search.from_date as string,
            to_date: search.to_date as string,
            recruiter_id: search.recruiter_id as string,
        }
    },
    component: RecruitmentPage,
})
